<template>
  <div style="height: 100%;">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件 -->
      </router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive">
      <!-- 这里是不被缓存的视图组件 -->
    </router-view>
  </div>
</template>

<script>
export default {};
</script>
<style>
@import url('./css/fonsize.css');
.u-support {
  width: .4rem;
  height: .4rem;
  pointer-events:none;
}
.u-supportActive {
  width: .4rem;
  height: .4rem;
  display: none;
  pointer-events:none;
}
.u-supportBox.active .u-support {
  display: none;
}
.u-supportBox.active .u-supportActive {
  display: inline;
}
.u-supportBox {
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: .16rem;
  color: #333;
  display: flex;
  align-items: center;
}
.u-supportBox img {
  margin-right: .0667rem;
}
</style>
